/**
 * /eric/clients — Clients table with health signals (T-051, PR-31).
 *
 * Route config only. Component lives in eric.clients.lazy.tsx (code-split).
 * No loader, beforeLoad, or validateSearch.
 */

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/eric/clients')({});
